import { useState } from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import { Box, Button, Chip } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { LoadingFeedback, MenuButton, Permitted } from 'components'

import ActionButtons from '../ActionButtons'

import { routes } from 'Routes'
import constants from 'constants/index'
import useStyles from './styles'

const TableRowOrganization = ({
  organization,
  refresh = () => {},
  setIsLoading,
  ...rest
}) => {
  const history = useHistory()
  const classes = useStyles()

  const navigateToShow = () => {
    history.push(
      reverse(routes.organizations.edit, {
        organizationId: organization?.id,
      }),
    )
  }

  const { DPONET_ORGANIZATION_ID, CS_ORGANIZATION_ID } = constants.organizations
  const { STATUS } = constants.organizationUsers

  const isDefault =
    organization?.id === DPONET_ORGANIZATION_ID ||
    organization?.id === CS_ORGANIZATION_ID

  return (
    <TableRow {...rest}>
      <TableCell>{organization?.id}</TableCell>
      <TableCell>{organization?.name}</TableCell>
      <TableCell>
        {constants.organizations.KIND_LABEL[organization?.kind]}
      </TableCell>
      <TableCell disableTooltip>
        <Chip
          className={clsx(classes.root, {
            [classes.active]: organization?.status === STATUS.ACTIVE,
            [classes.inactive]: organization?.status === STATUS.INACTIVE,
          })}
          align="center"
          size="small"
          label={organization?.status === STATUS.ACTIVE ? 'Ativa' : 'Inativa'}
        />
      </TableCell>
      <TableCell disableTooltip>{organization?.totalUsers}</TableCell>
      <TableCell disableTooltip>{organization?.totalCompanies}</TableCell>
      <Permitted tag={constants.permissions.ORGANIZATION.MANAGE}>
        <TableCell disableTooltip align="right">
          <MenuButton>
            <Button fullWidth size="small" onClick={navigateToShow}>
              Editar
            </Button>
            {!isDefault && (
              <ActionButtons
                organization={organization}
                refresh={refresh}
                setIsLoading={setIsLoading}
              />
            )}
          </MenuButton>
        </TableCell>
      </Permitted>
    </TableRow>
  )
}

const OrganizationsTable = ({ organizations, refresh }) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Box width="100%">
        <PerfectScrollbar
          options={{ wheelPropagation: true, useBothWheelAxes: true }}
        >
          <Table emptyMessage="Nenhuma empresa encontrada" noWrap>
            <TableHead>
              <TableRow>
                <TableCell width="10%">ID</TableCell>
                <TableCell width="25%" align="left">
                  Nome
                </TableCell>
                <TableCell width="25%" align="left">
                  Finalidade
                </TableCell>
                <TableCell width="15%" align="left">
                  Status
                </TableCell>
                <TableCell width="15%" align="left">
                  Usuários Vinculados
                </TableCell>
                <TableCell width="15%" align="left">
                  Empresas Vinculadas
                </TableCell>
                <Permitted tag={constants.permissions.ORGANIZATION.MANAGE}>
                  <TableCell width="10%" align="right">
                    Ações
                  </TableCell>
                </Permitted>
              </TableRow>
            </TableHead>
            <TableBody>
              {organizations?.map((organization) => (
                <TableRowOrganization
                  organization={organization}
                  key={organization?.id}
                  refresh={refresh}
                  setIsLoading={setIsLoading}
                  hover
                />
              ))}
            </TableBody>
          </Table>
        </PerfectScrollbar>
      </Box>
    </>
  )
}

OrganizationsTable.propTypes = {
  company: PropTypes.object,
  refresh: PropTypes.func,
  setIsLoading: PropTypes.func,
}

export default OrganizationsTable
